import { useSelector } from 'react-redux'
import React, { useState } from 'react'

import { loadSubsequentMilitaryResults, search } from '../../actions/military'
import SearchQueryHandlerComponent from '../../components/search/SearchQueryHandlerComponent'

const MilitarySearchResults = props => {
  const [filterModel, setFilterModel] = useState({})
  const loadFunction = search(props.location?.query?.q)
  const loadMoreFunction = loadSubsequentMilitaryResults(
    props.location?.query?.q,
    filterModel
  )
  const searchRequest = useSelector(state => state.military.searchRequest)

  return (
    <SearchQueryHandlerComponent
      loadFunction={loadFunction}
      loadMoreFunction={loadMoreFunction}
      setFilterModel={setFilterModel}
      searchRequest={searchRequest}
      {...props}
    />
  )
}

export default MilitarySearchResults
